import { type ReactNode } from "react";
import { DownloadIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { SearchInput } from "@vega-core/components/Form/Controls/Input/SearchInput/SearchInput";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@vega-core/components/shadcn/dropdown-menu";
import { m } from "@vega-core/paraglide/messages";

type ShareTableToolbarProps = {
  searchName: string;
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  searchDisabled?: boolean;
  renderFilters: ReactNode;
  exportTestId: string;
  isExporting: boolean;
  onExportCsv: () => void;
  onExportExcel: () => void;
  renderColumnToggle?: ReactNode;
  renderActions?: ReactNode;
};

export const ShareTableToolbar = ({
  searchName,
  searchQuery,
  onSearchQueryChange,
  searchDisabled,
  renderFilters,
  exportTestId,
  isExporting,
  onExportCsv,
  onExportExcel,
  renderColumnToggle,
  renderActions,
}: ShareTableToolbarProps) => (
  <div className="flex flex-wrap items-center justify-between gap-4">
    <SearchInput
      className="min-w-72"
      disabled={searchDisabled}
      name={searchName}
      onChange={(e) => onSearchQueryChange(e.target.value)}
      value={searchQuery}
      withBorder
    />
    <div className="flex-1">{renderFilters}</div>
    <div className="flex items-center gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <ThemedButton
            dataTestId={exportTestId}
            disabled={isExporting}
            icon={<DownloadIcon />}
            size="small"
            variant="secondary"
          >
            {m.btn_export()}
          </ThemedButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="p-2">
          <DropdownMenuItem onSelect={onExportCsv}>
            <DownloadIcon className="w-4 h-4" />
            <p className="body-base-medium">{m.btn_exportAsCsv()}</p>
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={onExportExcel}>
            <DownloadIcon className="w-4 h-4" />
            <p className="body-base-medium">{m.btn_exportAsExcel()}</p>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {renderColumnToggle}

      {renderActions}
    </div>
  </div>
);
